import { useV2ListQuestionnaireRecommendationsForQuestionnaireQuery } from "@generated";
import type {
  Recommendation,
  ItemType,
  ConditionType,
  ComparisonValueType,
} from "../types";

export const useRecommendationsList = (questionnaireId: string) => {
  const { data, isLoading, isFetching, refetch } =
    useV2ListQuestionnaireRecommendationsForQuestionnaireQuery(
      {
        questionnaireId: Number(questionnaireId),
        filter: { active: true },
        page: { size: 500 },
      },
      { refetchOnMountOrArgChange: true }
    );

  const rows: Recommendation[] = (data?.data ?? [])
    .map((r: any) => {
      const a = r.attributes ?? {};
      const refinements = (a.refinements ?? []).map((rf: any) => ({
        taskId: String(rf["task-id"] ?? rf.task_id ?? ""),
        quantityValue: rf["quantity-value"] ?? rf.quantity_value ?? "",
      }));
      return {
        id: String(r.id),
        quantityValue: a["quantity-value"] ?? "",
        itemId: a["item-id"] != null ? String(a["item-id"]) : "",
        itemType: (a["item-type"] ?? "Task") as ItemType,
        conditionType: (a["condition-type"] ?? "always") as ConditionType,
        conditionalValue: a["conditional-value"] ?? "",
        comparisonValue: a["comparison-value"] ?? "",
        comparisonValueType: (a["comparison-value-type"] ??
          "selected_value") as ComparisonValueType,
        position: a.position ?? 0,
        refinements,
      };
    })
    .sort((x: Recommendation, y: Recommendation) => x.position - y.position);

  return { rows, isLoading, isFetching, refetch };
};

export default useRecommendationsList;
